import { devApiUrl, prodApiUrl } from "@/globals";
import { api } from "roboflex-thalamus-request-handler/dist";
import { sso } from "roboflex-thalamus-sso-lib";

const link = "https://portal.thalamus.ind.br/#/";
const linkHomologacao = "https://portal-homologacao.thalamus.ind.br/#/";

const moduloService = {
    buscarModulos: async (buildMode) => {
        const usuarioLogado = sso.getUsuarioLogado();
        if (!usuarioLogado || usuarioLogado.id == null) {
            throw new Error("Usuário ainda não carregado");
        }
        var response;

        if (buildMode == "development" || buildMode == "staging") {
            response = await api.post(devApiUrl+"funcionalidade/cards/usuario", {
                usuario_id: usuarioLogado.id,
            });
        } else {
            response = await api.post(prodApiUrl+"funcionalidade/cards/usuario", {
                usuario_id: usuarioLogado.id,
            });
        }

        return response.data;
    },
    linkPortal(buildMode) {
        return buildMode == "staging" || buildMode == "development" ? linkHomologacao : link;
    },

    linkDadosCadastrais(buildMode) {
      let link = null;
      if(buildMode == "staging" || buildMode == "development") {
        link = "https://dados-basicos-homologacao.thalamus.ind.br/#/profile"
      } else {
        link = "https://dados-basicos.thalamus.ind.br/#/profile"
      }
      return link;
    },

    getPessoa: async () => {
        var response;
        response = await api.get(prodApiUrl+"pessoa/usuario");
        return response.data;
    }
};

export default moduloService;
